export default __webpack_public_path__ + "static/media/purple_down_arrow_icon.b1462c78.svg";